const GETTERS = {

}

export default GETTERS
